import { render, staticRenderFns } from "./KakaoPartnerInfoDetail.vue?vue&type=template&id=5deccdb4&scoped=true"
import script from "./KakaoPartnerInfoDetail.vue?vue&type=script&lang=js"
export * from "./KakaoPartnerInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./KakaoPartnerInfoDetail.vue?vue&type=style&index=0&id=5deccdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deccdb4",
  null
  
)

export default component.exports